import React from 'react';
import { result } from 'underscore';
import { curlyTemplate } from '@bingads-webui-universal/primitive-utilities';
import { Breadcrumb } from '@bingads-webui-react/breadcrumb';
import { Glyphicon } from '@bingads-webui-react/primitive';


export class SharedBudgetConsumer {
  constructor({ scope, i18n, budget }) {
    this.scope = scope;
    this.i18n = i18n;
    this.budget = budget;
  }

  get criteriaRenderer() {
    return {
      renderSharedBudgetAmount: this.renderSharedBudgetAmount,
      renderSharedBudgetType: this.renderSharedBudgetType,
      renderSharedBudgetBreadCrumb: this.renderSharedBudgetBreadCrumb,
    };
  }

  renderSharedBudgetAmount = ({ canEdit } = {}) => {
    const amount = this.budget.Amount;
    return (
      <div className="entity-text">
        {curlyTemplate(this.i18n.getString(_TL_('{{budget}}/day')))({ budget: amount.toFixed(2) })}
        {canEdit ? (
          <Glyphicon
            className="entity-icon"
            glyph="ba-Edit"
          />
        ) : null}
      </div>
    );
  };

  renderSharedBudgetType = () => {
    const typeLocalize = result({
      Accelerated: this.i18n.getString(_TL_('Accelerated')),
      DailyStandard: this.i18n.getString(_TL_('Standard')),
    }, this.budget.Type);

    return (<div className="entity-text">{typeLocalize}</div>);
  }

  renderSharedBudgetBreadCrumb = () => {
    const items = [{
      key: 'shared-library',
      text: this.i18n.getString(_TL_('Shared library')),
    }, {
      key: 'shared-budgets',
      text: this.i18n.getString(_TL_('Shared budgets')),
      onClick: () => {
        this.scope.remove('budgetId');
        this.scope.save('/campaign/vnext/sharedbudgets');
      },
    }, {
      key: 'shared-budget-name',
      text: this.budget.Name,
      isCurrentItem: true,
    }];

    return (
      <div className="summary-bar-breadcrumb">
        <Breadcrumb items={items} />
      </div>
    );
  };
}
